import React, {useState} from 'react';
import style from "./style.module.css"
import ModalWindow from "../ModalWindow";
import TelegramIcon from "../icons/TelegramIcon";
import WhatsappIcon from "../icons/WhatsappIcon";
import ViberIcon from "../icons/ViberIcon";
import SupportIcon from "../icons/SupportIcon";
import { t } from "i18next";
import { Trans } from 'react-i18next';

const SupportModal = ({ display = false, displayHeader = true, onClose }) => {
  const [isSupport, changeDisplaySupport] = useState(display)
  return (
    <div>
      { displayHeader && (
        <div className={style.footer} onClick={() => changeDisplaySupport(true)}>
          <SupportIcon />
          <span>{t('supportModal.title')}</span>
        </div>
      )}
      { isSupport &&
        <ModalWindow onClose={() => {changeDisplaySupport(false); if (onClose) onClose()}} >
          <div className={style.wrapper}>
            <h3 className={style.title}>{t('supportModal.helpPrompt')}</h3>
            <p className={style.summary}>{t('supportModal.messagePrompt')}</p>
            <div className={style.block}>
              <a href="https://t.me/biny_support" target="_blank">
                <TelegramIcon />
              </a>
              <a href="https://wa.me/77711031141" target="_blank">
                <WhatsappIcon />
              </a>
            </div>
            <p className={style.summary}>{t('supportModal.callPrompt')}</p>
            <div className={style.block}>
              <a href="tel:+77711031141" className={style.phone}>+77711031141</a>
            </div>
            <p className={style.summary}>
              <Trans
                  i18nKey="supportModal.workingHours"
                  components={{
                    br: <br />,
                    1: <strong />,
                    3: <strong />
                  }}
              />
            </p>
          </div>
        </ModalWindow>}
    </div>
  );
};

export default SupportModal;